import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import {
   ModalBackground,
   ModalDialog,
   ModalFooter,
   ModalContent,
} from '../../../styledComponents/ModalStyledComponents';

import { PropTypes } from 'prop-types';
import { isTokenStillValid, clear } from '../../../misc/BrowserStorageManager';
import { history } from '../../../redux/store/configureStore';

function Modal({ closeModal, children, hint }) {
   const modalDomEl = document.getElementById('modal');
   const modalContent = useRef(null);

   // check if JWT is still valid when zoom is open
   useEffect(() => {
      if (!isTokenStillValid()) {
         const { pathname, search } = history.location;
         clear();
         history.push(pathname + search);
      }
   }, []);

   const handleClickOutside = (event) => {
      if (!modalContent.current.contains(event.target)) {
         closeModal();
      }
   };

   if (!modalDomEl) return null;

   return ReactDOM.createPortal(
      <ModalBackground onClick={handleClickOutside}>
         <ModalDialog>
            <ModalContent ref={modalContent}>
               {children}
               <ModalFooter>
                  {hint && (
                     <span style={{
                        marginRight: 'auto',
                        fontSize: '13px',
                        color: '#555',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                     }}>
                        <i className='bi bi-clipboard' style={{ fontSize: '14px' }} />
                        {hint}
                     </span>
                  )}
                  <button type='button' className='btn btn-danger' onClick={closeModal}>
                     Close
                  </button>
               </ModalFooter>
            </ModalContent>
         </ModalDialog>
      </ModalBackground>,
      modalDomEl,
   );
}

Modal.propTypes = {
   children: PropTypes.node,
   closeModal: PropTypes.func,
   hint: PropTypes.string,
};

export default Modal;
